import LazyLoad from 'vanilla-lazyload';

export default function () {
  var projectLazyImg = new LazyLoad({
      elements_selector: ".lazy img",
      container: document.getElementById('side-panel-content'),
      threshold: 300,
      callback_loaded: (el) => {
        el.parentElement.classList.add('loaded');
      }
  });
}
